// MO4.1.3
// TierPromotionCard the smartest - is aware of business logic and picks which CTA button to show
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import TierPromotionCardSemiDumb from '../TierPromotionCardSemiDumb';
import { useTierPromotionCardCtaType } from './useTierPromotionCardCtaType';
import s from './TierPromotionCard.scss';
const TierPromotionCard = (_param)=>{
    var { deviation, onClick, ctaClassname, fakeCTAButton, verticalLayout } = _param, props = _object_without_properties(_param, [
        "deviation",
        "onClick",
        "ctaClassname",
        "fakeCTAButton",
        "verticalLayout"
    ]);
    const ctaButton = useTierPromotionCardCtaType(deviation);
    if (!deviation.tier) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, _object_spread({
        deviation: deviation,
        onClick: ()=>onClick && onClick(deviation),
        ctaButton: ctaButton,
        ctaClassname: c(ctaClassname, fakeCTAButton && s['fake-button']),
        verticalLayout: verticalLayout
    }, props));
};
TierPromotionCard.displayName = 'TierPromotionCard';
export default TierPromotionCard;

//# sourceMappingURL=TierPromotionCard.js.map